module.exports = __webpack_public_path__ + "332cc96.woff";